import isString from "lodash/isString";
export const sortWithLocale = language => (a, b) => {
  if (isString(a) && isString(b)) {
    return new Intl.Collator(language).compare(a, b);
  }
  if (a > b) {
    return 1;
  }
  if (a < b) {
    return -1;
  }
  return 0;
};